/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { Object3D } from 'three';
// TODO: This should be present in `package.json`.
import { Text } from 'troika-three-text';

import type CardGL from '../../CardFGUp';

import PerformanceProfile from '../../../../utils/PerformanceProfile';

const GLOBAL_CONFIG = {
    letterSpacingNumber: -0.035,
    letterSpacingText: 0.0,
    fontSize: 0.25,
    margin: 0.2,
    color: '#ffe3e3',
};

let GUI;

const addGUI = async () => {
    await PerformanceProfile.devModeReady();

    GUI = PerformanceProfile.GUI.floorGameDown.addFolder({
        title: 'Text 3D',
        expanded: false,
    });

    GUI.addButton({ title: 'Export Config' }).on('click', () => {
        // TODO: What is `CONFIG`?
        PerformanceProfile.exportConfig('Text3D', { ...GLOBAL_CONFIG, ...CONFIG });
    });

    GUI.addInput(GLOBAL_CONFIG, 'letterSpacingNumber', { min: -0.1, max: 0, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'letterSpacingText', { min: -0.1, max: 0, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'fontSize', { min: 0.1, max: 1, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'margin', { min: 0.01, max: 0.3, step: 0.001 });
    GUI.addInput(GLOBAL_CONFIG, 'color');
};

if (PerformanceProfile.devMode) addGUI();

interface CardFloorTextOptions {
    card: CardGL;
    // TODO: What is with this type?
    // Should it be a `number` or an array?
    floorPrice: number | unknown[];
}

export default class CardFloorText extends Object3D {
    card: CardGL;
    text: Text;
    texts: Array<Text>;

    // TODO: These need to be defined in the constructor.
    textSize: number;
    textMargin: number;
    textColor: string;

    time = 0.0;
    visible = false;
    ready = false;

    constructor({ card, floorPrice }: CardFloorTextOptions) {
        super();

        this.card = card;
        this.texts = [];

        this.initText(Array.isArray(floorPrice) ? floorPrice.length : floorPrice);

        const textScale = Array.isArray(floorPrice) && floorPrice.length > 4 ? (floorPrice.length - 3) * 0.08 : 0;

        this.scale.set(1.0 - textScale, 1.0 - textScale, 1);
    }

    initText(value: number) {
        this.textSize = GLOBAL_CONFIG.fontSize;
        this.textMargin = GLOBAL_CONFIG.fontSize * GLOBAL_CONFIG.margin;

        // TODO: troika-three-text is missing type definitions.
        const text = new Text();
        this.add(text);

        text.font = '/assets/fonts/tusker-grotesk-4500-medium-webgl.woff';
        text.text = value.toString();
        text.fontSize = this.textSize;
        text.textAlign = 'center';
        text.anchorX = 'center';
        text.anchorY = 'middle';
        text.letterSpacing = GLOBAL_CONFIG.letterSpacingNumber;

        text.__crypto = new Text();
        text.add(text.__crypto);
        text.__crypto.font = '/assets/fonts/tusker-grotesk-4500-medium-webgl.woff';
        text.__crypto.text = 'ETH';
        text.__crypto.fontSize = this.textSize * 0.3;
        text.__crypto.position.y = this.textSize * -0.5 - this.textMargin;
        text.__crypto.textAlign = 'center';
        text.__crypto.anchorX = 'center';
        text.__crypto.anchorY = 'middle';
        text.__crypto.letterSpacing = GLOBAL_CONFIG.letterSpacingText;

        text.color = GLOBAL_CONFIG.color;
        text.__crypto.color = GLOBAL_CONFIG.color;

        text.__saveY = text.position.y;

        text.sync();
        text.__crypto.sync();
        this.texts.push(text);

        text.addEventListener('synccomplete', () => {
            setTimeout(() => {
                this.ready = true;
            }, 50);
        });

        if (PerformanceProfile.devMode) GUI.on('change', this.updateTextConfig.bind(this));
    }

    updateTextConfig() {
        this.textSize = GLOBAL_CONFIG.fontSize;
        this.textMargin = GLOBAL_CONFIG.fontSize * GLOBAL_CONFIG.margin;

        this.texts.forEach((text) => {
            text.fontSize = this.textSize;
            text.letterSpacing = GLOBAL_CONFIG.letterSpacingNumber;
            text.color = GLOBAL_CONFIG.color;
            text.sync();

            text.__crypto.fontSize = this.textSize * 0.3;
            text.__crypto.position.y = this.textSize * -0.5 - this.textMargin;
            text.__crypto.letterSpacing = GLOBAL_CONFIG.letterSpacingText;
            text.__crypto.color = GLOBAL_CONFIG.color;
            text.__crypto.sync();
        });

        this.visible = true;
        this.position.z = 3.0;
    }

    animateIn() {
        this.visible = true;
        this.position.z = 3.0;
    }

    setPosition(_width: number, _height: number) {
        // TODO: Implement method.
    }

    update(_elapsed: number) {
        // TODO: Implement method.
    }

    delete() {
        this.texts.forEach((text) => {
            this.remove(text);
            text.__crypto.dispose();
            text.dispose();
        });
    }
}
